import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=9b2ac66e&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=9b2ac66e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2ac66e",
  null
  
)

export default component.exports